<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader shadow-header-footer">
            <div class="left">
                <a
                    @click="$router.go(-1)"
                    class="headerButton"
                    style="cursor: pointer"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Riwayat Points</div>
            <!-- <div class="right">
                <a class="headerButton" @click="refresh()">
                    <ion-icon name="sync-sharp"></ion-icon>
                </a>
            </div> -->
        </div>
        <!-- * App Header -->

        <!-- Extra Header -->
        <div class="extraHeader pr-0 pl-0">
            <ul class="nav nav-tabs lined" role="tablist">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: ComponentActivity == true }"
                        @click="showComponentActivity"
                    >
                        Aktivitas
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: ComponentRedeem == true }"
                        @click="showComponentRedeem"
                    >
                        Penukaran
                    </a>
                </li>
            </ul>
        </div>
        <!-- * Extra Header -->

        <div id="appCapsule" class="extra-header-active">
            <!-- Transactions -->
            <div class="section full tab-content mb-2 mt-1">
                <!-- Activiy tab -->
                <div
                    class="tab-pane"
                    :class="{ 'show active': ComponentActivity == true }"
                >
                    <ComponentActivity
                        :data="activity"
                        :loadingButton="loadingButton"
                        :loadingApp="loadingApp"
                        @paginate="paginateActivity(activity.next_page_url)"
                    >
                    </ComponentActivity>
                </div>
                <!-- * Activiy tab -->

                <!-- Redeem tab -->
                <div
                    class="tab-pane"
                    :class="{ 'show active': ComponentRedeem == true }"
                >
                    <ComponentRedeem
                        :data="redeem"
                        :loadingButton="loadingButton"
                        :loadingApp="loadingApp"
                        @paginate="paginateRedeem(redeem.next_page_url)"
                    >
                    </ComponentRedeem>
                </div>
                <!-- * Redeem tab -->
            </div>
            <!-- * Transactions -->
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    moment.locale('id');
    import $axios from './../../../api.js';
    import ComponentActivity from './ComponentActivity';
    import ComponentRedeem from './ComponentRedeem';
    import { mapState } from 'vuex';
    export default {
        name: 'points.history',
        components: {
            ComponentActivity,
            ComponentRedeem,
        },
        data() {
            return {
                ComponentActivity: false,
                ComponentRedeem: false,
                activity: {
                    data: [],
                    keywords: '',
                },
                redeem: {
                    data: [],
                    keywords: '',
                },
                loadingApp: true,
                loadingButton: false,
            };
        },
        created() {
            this.ComponentActivity = true;
            this.paginateActivity();
        },
        computed: {
            ...mapState(['toast']),
        },
        methods: {
            showComponentActivity() {
                if (this.ComponentActivity == false) {
                    this.ComponentActivity = true;
                    this.ComponentRedeem = false;
                    this.loadingApp = true;
                    this.activity = {
                        data: [],
                        keywords: '',
                    };
                    this.RESET_LOADING();
                    this.paginateActivity();
                }
            },
            showComponentRedeem() {
                if (this.ComponentRedeem == false) {
                    this.ComponentRedeem = true;
                    this.ComponentActivity = false;
                    this.redeem = {
                        data: [],
                        keywords: '',
                    };
                    this.RESET_LOADING();
                    this.paginateRedeem();
                }
            },

            paginateActivity(url = '') {
                this.loadingButton = true;
                $axios
                    .get(url ? url : '/points/history/activity')
                    .then(response => {
                        if (!this.activity.data) {
                            this.activity = response.data.data;
                        } else {
                            this.activity.data.push(...response.data.data.data);
                            this.activity.to = response.data.data.to;
                            this.activity.per_page =
                                response.data.data.per_page;
                            this.activity.next_page_url =
                                response.data.data.next_page_url;
                        }
                        this.loadingButton = false;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingButton = false;
                        this.loadingApp = false;
                    });
            },
            paginateRedeem(url = '') {
                this.loadingButton = true;
                $axios
                    .get(url ? url : '/points/history/redeem')
                    .then(response => {
                        if (!this.redeem.data) {
                            this.redeem = response.data.data;
                        } else {
                            this.redeem.data.push(...response.data.data.data);
                            this.redeem.next_page_url =
                                response.data.data.next_page_url;
                        }
                        this.loadingButton = false;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingButton = false;
                        this.loadingApp = false;
                    });
            },

            refresh() {
                this.loadingApp = true;
                if (this.ComponentActivity == true) {
                    this.activity = {
                        data: [],
                        keywords: this.activity.keywords,
                    };
                    this.paginateActivity();
                } else {
                    this.redeem = {
                        data: [],
                    };
                    this.paginateRedeem();
                }
            },
            RESET_LOADING() {
                this.loadingApp = true;
                this.loadingButton = false;
            },
        },
    };
</script>
